import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

function SessionWaitingTime(props) {
  const calculateTimeLeft = () => {
    const datetime = dayjs(props.date).diff(dayjs(new Date()));

    let timeLeft = {};

    if (datetime > 0) {
      timeLeft = {
        days: Math.floor(datetime / (1000 * 60 * 60 * 24)),
        hours: Math.floor((datetime / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((datetime / 1000 / 60) % 60),
        seconds: Math.floor((datetime / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }
  });

  return (
    <>
      <div className="waitingTimer d-inline-flex align-content-center justify-center rounded border border-white mt-4 bg-white bg-opacity-10 py-0 px-4 px-md-20">
        <div className="row flex-wrap my-0 mx-n4 mx-md-n20">
          <div className="col fs-30 text-white fw-semibold py-2 px-4 px-md-20">
            {timeLeft.days < 9 ? '0' + timeLeft.days : timeLeft.days}
            <span className="d-block fs-4 position-relative pt-2">Days</span>
          </div>

          <div className="col fs-30 text-white fw-semibold py-2 px-4 px-md-20">
            {' '}
            {timeLeft.hours < 9 ? '0' + timeLeft.hours : timeLeft.hours}
            <span className="d-block fs-4 position-relative pt-2">Hours</span>
          </div>

          <div className="col fs-30 text-white fw-semibold py-2 px-4 px-md-20">
            {timeLeft.minutes < 9 ? '0' + timeLeft.minutes : timeLeft.minutes}
            <span className="d-block fs-4 position-relative pt-2">Minutes</span>
          </div>

          <div className="col fs-30 text-white fw-semibold py-2 px-4 px-md-20">
            {timeLeft.seconds < 9 ? '0' + timeLeft.seconds : timeLeft.seconds}
            <span className="d-block fs-4 position-relative pt-2">Seconds</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default SessionWaitingTime;

// 2021-12-22 13:42:30
